import React from 'react';
import './TestComponent.css'
import { NavLink,Route, Switch } from 'react-router-dom';
import InvalidPath from '../NotFound';
import Destructrigprop from '../MainContentArea/Destructrigprop';
import VstateComponent from '../MainContentArea/V-stateComponent';
import  { EventClick ,PassMethodFromParntToChild } from '../MainContentArea/EventHandlingComponent';
import {ObjectLoopingComponent} from '../MainContentArea/ObjectLoopingComponent';
import ListofPracticeComponent from '../MainContentArea/ListofPracticeComponent';
import {AddMyPractice} from '../MainContentArea/AddMyPractice'
import FormEXComponent from '../MainContentArea/FormComponent'
const employees = [
    {Id:101,Name:'Abhinav',Location:'Bangalore',Salary:12345},  
    {Id:102,Name:'Abhishek',Location:'Chennai',Salary:23456},  
    {Id:103,Name:'Ajay',Location:'Bangalore',Salary:34567}  
  ];
function TestComponent(){
    return(
        <div className="TestRow-main">
        <div className="TestNav">
         <NavLink to={"/Personal/AddPractice/V-stateComponent"}>v-Statemanagement</NavLink><br/>
         <NavLink to={"/Personal/AddPractice/DestructureProps"}>PropDestructuring</NavLink><br/>
         <NavLink to={"/Personal/AddPractice/Event"}>EventHandling</NavLink><br/>      
         <NavLink to={"/Personal/AddPractice/MethodAsProperty"}>MethodAsProperty</NavLink><br/>
         <NavLink to={"/Personal/Practice/ServiceCalling"}>ServicesCall</NavLink><br/>   
         <NavLink to={"/Personal/Practice/AddMyPractice"}>AddMyPractice</NavLink><br/> 
         <NavLink to={"/Personal/Practice/Forms"}>FormExample</NavLink><br/> 
        </div>   
        <div className="Content">
        <Switch>             
             <Route exact path="/Personal/AddPractice" component={TestMainComponent} ></Route> 
             <Route exact path="/Personal/AddPractice/" component={TestMainComponent} ></Route>
             <Route exact path="/Personal/AddPractice/V-stateComponent" component={VstateComponent} ></Route>              
             <Route path="/Personal/AddPractice/DestructureProps" component={Destructrigprop}></Route>     
             <Route path="/Personal/AddPractice/Event"  component={EventClick}></Route>
             <Route path="/Personal/AddPractice/MethodAsProperty" component={PassMethodFromParntToChild}></Route>
             <Route path="/Personal/Practice/ServiceCalling"  component={ListofPracticeComponent}></Route>
             <Route path="/Personal/Practice/AddMyPractice"  component={AddMyPractice}></Route>
             <Route path="/Personal/Practice/Forms"  component={FormEXComponent}></Route>
             <Route component={InvalidPath}></Route>
        </Switch>     
        </div> 
        </div>    
    )
}
function TestMainComponent(){
    return (
        <h1>Welcome Ravi For Your  Additional Practice</h1>
    )
}
export default TestComponent